'use client';

import { useState, type FC } from 'react';
import { Button } from '../../../components/ui/Button';
import { cn } from '../../../utils/cn';
import { wikiExcerpt } from '../wikiText';
import { WikiName } from './WikiName';
import { wikiProse } from '../wikiTypography';

const LEAD_CHARS = 220;

interface WikiIntroClampProps {
  text: string;
  more: string;
  className?: string;
}

// WHY: на телефоне вступление свёрнуто до целых предложений (обрезка посреди слова читалась как ошибка); остаток в разметке, скрыт только визуально; на десктопе текст целиком
export const WikiIntroClamp: FC<WikiIntroClampProps> = ({ text, more, className }) => {
  const [expanded, setExpanded] = useState(false);
  const lead = wikiExcerpt(text, LEAD_CHARS);
  const rest = text.startsWith(lead) ? text.slice(lead.length).trim() : '';

  return (
    <div className="flex flex-col items-start">
      <p className={cn('m-0 max-w-[60ch] text-[17px] leading-[26px] text-label-primary', className)}>
        <WikiName name={wikiProse(rest ? lead : text)} mode="text" />
        {rest && (
          <span className={cn(!expanded && 'max-lg:hidden')}>
            {' '}
            <WikiName name={wikiProse(rest)} mode="text" />
          </span>
        )}
      </p>
      {rest && !expanded && (
        <Button
          type="button"
          variant="tertiary"
          size="s"
          onClick={() => setExpanded(true)}
          className="min-h-10 bg-transparent px-0 text-[15px] font-medium text-accent-blue lg:hidden"
        >
          {more}
        </Button>
      )}
    </div>
  );
};
